import {AvatarMenuItem} from '@coolcolduk/ui-mui';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import {signOut} from 'firebase/auth';
import {NavigateFunction} from 'react-router';
import {User} from '@cp/model';
import {firebaseAuth} from '../../config/firebase';
import {adminTabs} from '../../pages/admin/adminTabs';
import {filterTabs, hasAnyPageAccess} from '../../pages/admin/filterTabs';

export const createUserMenu = (navigate: NavigateFunction, user?: User) => {
  const accessibleTabs = filterTabs(adminTabs, user?.roles);
  const hasAdminAccess = hasAnyPageAccess(adminTabs, user?.roles);
  // Get first non-parameterized tab for navigation
  const firstAccessibleTab = accessibleTabs.find((tab) => !tab.path.includes(':')) || accessibleTabs[0];

  return [
    {label: 'Settings', icon: <SettingsIcon />, onClick: () => navigate('/settings/general')},
    ...(hasAdminAccess && firstAccessibleTab
      ? [
          {
            label: 'Admin',
            icon: <AdminPanelSettingsIcon />,
            onClick: () => navigate(firstAccessibleTab.path),
          },
        ]
      : []),
    {
      label: 'Logout',
      icon: <LogoutIcon />,
      onClick: async () => {
        await signOut(firebaseAuth);
        navigate('/login');
      },
    },
  ] as AvatarMenuItem[];
};
